'use client'

import { CSSProperties } from 'react'

import { useSearchFilterStore } from '@/entities/map'
import { RoomSortOption } from '@/entities/room'
import { Select } from '@/shared/ui'

const sortOptionLabelMap: Record<RoomSortOption, string> = {
  [RoomSortOption.POPULAR]: '인기순',
  [RoomSortOption.LOW_PRICE]: '낮은 가격순',
  [RoomSortOption.HIGH_PRICE]: '높은 가격순',
  [RoomSortOption.RECENT]: '최근 등록순',
}

type Props = {
  selected?: RoomSortOption
  height?: number
  alignOffset?: number
  className?: string
}

export const OrderSelect = ({ height, alignOffset, className }: Props) => {
  const sort = useSearchFilterStore(state => state.sort)
  const filterActions = useSearchFilterStore(state => state.actions)

  const handleValueChange = (newValue: RoomSortOption) => {
    filterActions.updateSort(newValue)
  }

  return (
    <div className={className}>
      <Select.Root
        mode="menu"
        required={true}
        value={sort}
        readOnly={false}
        onValueChange={handleValueChange}
        width={81}
      >
        <Select.Trigger
          variant="text"
          className="h-[var(--select-height)] w-fit justify-start focus-visible:ring-0 focus-visible:outline-none"
          style={{ '--select-height': `${height}px` } as CSSProperties}
        >
          {sortOptionLabelMap[sort]}
        </Select.Trigger>
        <Select.Content
          variant="text"
          side="bottom"
          shadow
          alignOffset={alignOffset}
          align="end"
          className="min-w-24"
        >
          <Select.Group>
            {Object.entries(sortOptionLabelMap).map(([value, label]) => (
              <Select.Item key={value} value={value}>
                {label}
              </Select.Item>
            ))}
          </Select.Group>
        </Select.Content>
      </Select.Root>
    </div>
  )
}
